import React from "react";
import useCustomizerStore from "../../../state/customizer";
import { isMobile } from "react-device-detect";
import { motion } from "framer-motion";

const Carousel = () => {
  const model = useCustomizerStore((s) => s.model);
  const setModel = useCustomizerStore((s) => s.setModel);
  const mobileSize = "6.4px";
  const desktopSize = "8.8px";

  const Dot0_Styles = {
    backgroundColor: model === 0 ? "#fff" : "#666",
    width: isMobile ? mobileSize : desktopSize,
    height: isMobile ? mobileSize : desktopSize,
    marginBottom: isMobile ? mobileSize : desktopSize,
    borderRadius: "50%",
    cursor: "pointer",
  };
  const Dot1_Styles = {
    backgroundColor: model === 1 ? "#fff" : "#666",
    width: isMobile ? mobileSize : desktopSize,
    height: isMobile ? mobileSize : desktopSize,
    marginBottom: isMobile ? mobileSize : desktopSize,
    borderRadius: "50%",
    cursor: "pointer",
  };
  const Dot2_Styles = {
    backgroundColor: model === 2 ? "#fff" : "#666",
    width: isMobile ? mobileSize : desktopSize,
    height: isMobile ? mobileSize : desktopSize,
    marginBottom: isMobile ? mobileSize : desktopSize,
    borderRadius: "50%",
    cursor: "pointer",
  };
  return (
    <motion.div
      key="carousel"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      style={{
        position: "absolute",
        zIndex: "1200",
        right: isMobile ? "7%" : "5%",
        top: isMobile ? "70px" : "52.5%",
      }}
    >
      <div onClick={() => setModel(0)} style={Dot0_Styles}></div>
      <div onClick={() => setModel(1)} style={Dot1_Styles}></div>
      <div onClick={() => setModel(2)} style={Dot2_Styles}></div>
    </motion.div>
  );
};

export default React.memo(Carousel);
